export const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "20px",
  },
  textarea: {
    height: "100%",
    width: "100%",
    overflow: "auto",
  },
  button: {
    border: "none",
    color: "black",
    borderRadius: "4px",
    padding: "0.75rem",
    fontSize: "1rem",
    fontWeight: 700,
    cursor: "pointer",
  },
  rawContent: {
    width: '100%',
    border: '2px solid #ddd',
    borderRadius: 5,
    flexBasis: "100%",
    padding: "10px",
    height: "100%",
    overflow: "auto",
  },
  emailbody: {
    border: "1px solid #ccc",
    borderRadius: 4,
    flexBasis: "100%",
    width: '40vw',
  },
  bhValue: {
    marginTop: "20px",
    width: "100%",
    border: "1px solid #ccc",
    padding: "10px",
    backgroundColor: "#f0f0f0",
  },
  highlightedContent: {
    marginTop: "20px",
    width: "100%",
    border: "1px solid #ccc",
    padding: "10px",
    backgroundColor: "#e0e0e0",
    whiteSpace: "pre-wrap",
    wordWrap: "break-word",
  },
  bytesContainer: {
    display: "flex",
    flexWrap: "wrap",
  },
  byte: {
    marginRight: "2px",
    fontFamily: "monospace",
  },
};
